// ABOUTME: Builds the return address for passwordless sign-in emails.
// ABOUTME: The link comes back to the origin that requested it, so every host and port works.

/** The `/email-signin` route on the given origin, e.g. `window.location.origin`. */
export function emailSignInUrl(origin: string): string {
  return `${origin}/email-signin`;
}
